import Service from "../../../Services/index";
import OverviewSale from "../../../Services/api/Sale/OverviewForSaleAPI";

const overViewSale = {
    namespaced: true,
    state: {
        //seller order
        seller_search_amount : {
            date : [],
            sale : null
        }
    },
    mutations: {
        CLEAR_SEARCH_FOR_OVERVIEW : (state)=>{
            state.seller_search_amount = {
                date : [],
                sale_id : null
            }
        },
    },
    actions: {
        //for seller order
        getPerDay({commit},{start_date, end_date, sale_id}){
            return Service.OverviewSale.getPerDay(start_date,end_date,sale_id);
        },
        clearSearchForOverview({commit}){
            commit("CLEAR_SEARCH_FOR_OVERVIEW")
        },
        //report
        downloadCommissionSale({commit},data) {
            return Service.OverviewSale.downloadCommissionSale(data.sale_id,data.start_date,data.end_date);
        },
        downloadPromotionSale({commit},data) {
            return Service.OverviewSale.downloadPromotionSale(data.sale_id,data.start_date,data.end_date);
        },
        downloadCnSaleReport({commit},data) {
            return Service.OverviewSale.downloadCnSaleReport(data.sale_id,data.start_date,data.end_date)
        },
        downloadCustomerSaleReport({commit},data) {
            return Service.OverviewSale.downloadCustomerSaleReport(data.sale_id,data.year);
        },
        downloadProductSaleReport({commit},date) {
            return Service.OverviewSale.downloadProductSaleReport(date);
        },
        downloadRvSaleReport({commit},data) {
            return Service.OverviewSale.downloadRvSaleReport(data.sale_id,data.start_date,data.end_date)
        }
    }
};

export default overViewSale;
